{
	"products": "Produtos",
	"selectDisclaimer": "Realize download dos produtos selecionados em excel e edite-os. Em seguida faça upload do arquivo para atualizarmos seu cardápio",
	"xlsxDisclaimer": "Agora que você fez a edição dos produtos em excel, faça upload do arquivo que iremos atualizar sua lista de produtos neste cardápio",
	"label": "Nome do arquivo",
	"download": "Download",
	"editMassProduct": "Edição de produtos em massa",
	"sheet": {
		"id": "IDENTIFICADOR (NÃO EDITAR)",
		"sku": "SKU",
		"name": "Nome",
		"category": "Categoria",
		"description": "Descrição",
		"price": "Preço",
		"filename": "editar-produtos-em-massa-delivery",
		"invalidFormat": "Formato inválido"
	}
}
